import { useMemo } from "react";

import { currentWeek, recentWeeks, weekShortLabel, type IsoWeek } from "../lib/week";
import { SelectField, type SelectOption } from "./SelectField";

/**
 * An ISO week picked from the last `count` weeks (most recent first). A plain select rather than
 * `<input type="week">`, which Firefox and Safari do not render.
 */
export function WeekSelect({
  label,
  value,
  onChange,
  emptyLabel,
  count = 52,
  last,
  id,
}: {
  label: string;
  value: IsoWeek | "";
  onChange: (week: IsoWeek | "") => void;
  /** When set, an empty choice with this label comes first ("Toutes"). */
  emptyLabel?: string;
  count?: number;
  last?: IsoWeek;
  id?: string;
}) {
  const options = useMemo<SelectOption[]>(() => {
    const weeks = recentWeeks(count, last ?? currentWeek());
    // Keep an older selected week (from the URL) selectable.
    if (value && !weeks.includes(value)) weeks.push(value);
    const list = weeks.map((week) => ({ value: week, label: weekShortLabel(week) }));
    return emptyLabel ? [{ value: "", label: emptyLabel }, ...list] : list;
  }, [count, last, value, emptyLabel]);
  return <SelectField id={id} label={label} value={value} onChange={onChange} options={options} />;
}
